import React from 'react';
function PackageBed() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.8 108.8">
			<g id="Layer_2" data-name="Layer 2">
				<g id="Base_Circle" data-name="Base Circle">
					<path d="M54.4,3A51.4,51.4,0,1,1,3,54.4,51.46,51.46,0,0,1,54.4,3m0-3a54.4,54.4,0,1,0,54.4,54.4A54.4,54.4,0,0,0,54.4,0Z" />
				</g>
				<g id="Bed">
					<polyline className="cls-1" points="20.4 72.65 20.4 54.32 88.4 54.32 88.4 72.65" />
					<line className="cls-1" x1="20.4" y1="57.98" x2="20.4" y2="38.15" />
					<rect className="cls-1" x="26.38" y="41.57" width="18.1" height="7.17" rx="3.53" ry="3.53" />
					<rect className="cls-2" x="20.4" y="53.82" width="68" height="8.5" />
				</g>
			</g>
		</svg>
	);
}
export default PackageBed;


/** WEBPACK FOOTER **
 ** ./src/modules/images/PackageBed.js
 **/